import { useState } from 'react';

import { OnAirList } from './OnAirList';
import { useLiveHosts } from './useLiveHosts';

/**
 * The header's live count (§6.8).
 *
 * ## It disappears when nobody is on air
 *
 * Which is most of the time, especially early. A permanent control reading
 * "0 live" is a standing advertisement that the best feature on the site is
 * empty, and people stop looking at chrome that has never once been worth
 * looking at.
 *
 * So it is absent by default and arrives - in the live red, mid-bar, animated -
 * only when there is genuinely something to hear. That is what makes it worth
 * noticing when it does show up.
 *
 * ## Centre of the bar
 *
 * Between the search box and the nav, which is the one piece of header real
 * estate nothing else claims. It is also where the eye already is on the way
 * from the logo to the account menu.
 */
export function OnAirButton() {
  const [open, setOpen] = useState(false);
  const { count } = useLiveHosts();

  if (count === 0) return null;

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        data-on-air-count={count}
        aria-label={count === 1 ? '1 host on air' : `${count} hosts on air`}
        className="flex shrink-0 items-center gap-2 rounded-[var(--radius-pill)] border border-hot-edge bg-hot-wash px-3.5 py-2 transition-colors hover:border-hot"
      >
        <span className="h-2 w-2 animate-pulse rounded-full bg-hot" aria-hidden />
        <span className="meta-caps whitespace-nowrap text-hot-text">
          {/* The number first, because it is the part that changes and the part
              somebody is scanning for. */}
          {count} live
        </span>
      </button>

      {open && <OnAirList onClose={() => setOpen(false)} />}
    </>
  );
}
